import { AlertAppID } from "../alerts";
import { SortDirection } from "../types";
import {
  isSheduledActivity,
  ResidentActivityType,
} from "../residentActivityPlan";

export interface AppStateRepeatAlert {
  isLoading: boolean;
  settings: RepeatAlertSettings;
  nodeDataNew: RepeatNotificationData;
}

export type RepeatNotificationData = {
  [key: number]: NodeRepeatNotification;
};

export type NodeRepeatNotification = {
  notificationRepeatCount: number;
  notificationMessageInclude: RepeatInclude[];
  notificationRepeatIntervalInSeconds: number;
  notifications: Notification[];
};
export type NodeRepeatNotificationExpand = NodeRepeatNotification & {
  nodeId: number;
};

export type Notification = AlertAppID | ResidentActivityType;

export type NodeRepeatNotificationDTO = NodeRepeatNotification & {
  nodeIds: number[];
};

export type RepeatAlertSettings = {
  searchValue?: string;
  selectedNodeIds?: number[];
  sort?: SortDirection;
};

export enum RepeatInclude {
  ROOM = "room",
  BED = "bed",
}

// export const newNodeDataStub: RepeatNotificationData = {
//     [467]: {
//         notificationRepeatCount: 2,
//         notificationMessageInclude: [RepeatInclude.ROOM, RepeatInclude.BED],
//         notificationRepeatIntervalInSeconds: 300,
//         notifications: [
//             AlertAppID.HRThresholds,
//             AlertAppID.RRThresholds,
//             AlertAppID.BTThresholds,
//             AlertAppID.Fall,
//             ResidentActivityType.REPLACE_CLOTHING,
//             ResidentActivityType.EATING,
//             ResidentActivityType.DRINKING,
//         ],
//     },

//     [1788]: {
//         notificationRepeatCount: 1,
//         notificationMessageInclude: [RepeatInclude.ROOM],
//         notificationRepeatIntervalInSeconds: 600,
//         notifications: [
//             AlertAppID.HRThresholds,
//             AlertAppID.RRThresholds,
//             AlertAppID.PressureUlcers,
//             ResidentActivityType.DIAPER,
//             ResidentActivityType.WALKING,
//             ResidentActivityType.STANDING,
//         ],
//     },
// };

export const defaultAlerts = [
  AlertAppID.FallDetected,

  AlertAppID.Fall,

  AlertAppID.HRThresholds,
  AlertAppID.RRThresholds,
  AlertAppID.BPThresholds,
  AlertAppID.BTThresholds,
  AlertAppID.SpO2Thresholds,
  AlertAppID.PressureUlcers,
  AlertAppID.InBed,
  AlertAppID.OutOfBed,
  AlertAppID.AwayFromBed,
  AlertAppID.CallButton,
  AlertAppID.UserNearby,
];
export const GROUP_AUDIO_SETTINGS_STUB = (
  alerts: any[] = defaultAlerts
): NodeRepeatNotification => {
  const res = {
    notificationRepeatCount: 1,
    notificationMessageInclude: [],
    notificationRepeatIntervalInSeconds: 0,
    notifications: alerts,
  };

  Object.values(ResidentActivityType).map(
    (el) => isSheduledActivity(el) && res.notifications.push(el)
  );
  return res;
};
